<script setup lang="ts">
/**
 * MobileMain — full-width scrollable content area for mobile viewports.
 * Renders only the routed view; InfoViewLayout and ConversationLayout are
 * omitted on mobile.
 */
</script>

<template>
  <div class="mobile-main w-full h-full overflow-auto">
    <RouterView />
  </div>
</template>

<style>
.mobile-main {
  --width-tufte-article: 100%;
  --max-width-tufte-article: none;
  --padding-tufte-article-y: 0;
  --padding-tufte-article-left: 0;
  --width-tufte-main: 100%;
  --width-tufte-list: 100%;
  --width-tufte-figcaption: 100%;
}

.mobile-main article {
  width: 100%;
  max-width: none;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}
</style>
